import { useEffect, useState } from "react";
import api from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "../ui/select";

export function Field({ label, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-baseline gap-0.5 sm:gap-3 py-1.5">
      <dt className="text-xs sm:text-sm text-slate-500 sm:w-36 shrink-0">{label}</dt>
      <dd className="text-sm text-slate-900 min-w-0 break-words">{children}</dd>
    </div>
  );
}

const TONES = {
  slate: "bg-slate-100 text-slate-700", emerald: "bg-emerald-50 text-emerald-700", sky: "bg-sky-50 text-sky-700", red: "bg-red-50 text-red-700",
};
export function StateBadge({ label, tone = "slate", testid }) {
  return <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${TONES[tone] || TONES.slate}`} data-testid={testid}>{label}</span>;
}

// The active accounts one may name as responsible (the server's own list: id and name only).
export function OwnerSelect({ value, onChange, testid = "owner" }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/marketing/owner-options").then(({ data }) => { if (alive) setItems(data.items || []); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger className="h-10" aria-label="Responsable" data-testid={testid}><SelectValue placeholder="Choisir une personne" /></SelectTrigger>
      <SelectContent>{items.map((o) => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}</SelectContent>
    </Select>
  );
}

const NO_ORIGIN = "__none__";

// « Campagne / partenaire » while a prospect is created: becomes one origin touch on the server. Nothing is shown while the module is off or
// when there is no campaign nor partner to choose from.
export function CreationOriginField({ value, onChange }) {
  const { user } = useAuth();
  const enabled = !!user?.features?.marketing;
  const [options, setOptions] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    api.get("/marketing/origin-options").then(({ data }) => { if (alive) setOptions(data); }).catch(() => {});
    return () => { alive = false; };
  }, [enabled]);
  if (!options || (options.campaigns.length === 0 && options.partners.length === 0)) return null;
  return (
    <div className="space-y-1.5 md:col-span-2" data-testid="creation-origin">
      <label className="text-xs font-medium text-slate-700">Campagne ou partenaire (facultatif)</label>
      <Select value={value || NO_ORIGIN} onValueChange={(v) => onChange(v === NO_ORIGIN ? "" : v)}>
        <SelectTrigger aria-label="Campagne ou partenaire" data-testid="creation-origin-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NO_ORIGIN}>Aucune</SelectItem>
          {options.campaigns.length > 0 && <SelectGroup><SelectLabel>Campagnes</SelectLabel>{options.campaigns.map((c) => <SelectItem key={c.id} value={`campaign:${c.id}`}>{c.name}</SelectItem>)}</SelectGroup>}
          {options.partners.length > 0 && <SelectGroup><SelectLabel>Partenaires</SelectLabel>{options.partners.map((p) => <SelectItem key={p.id} value={`partner:${p.id}`}>{p.name}</SelectItem>)}</SelectGroup>}
        </SelectContent>
      </Select>
    </div>
  );
}
